import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// When adding or renaming a route, also update the "Handle History Mode" rule of public/web.config,
// otherwise the server answers that URL with a 404 status
const routes = [
    {
        path: "/",
        name: "خانه",
        component: () => import('@/Pages/HomePage'),
        meta: {transition: 'zoom'},
    },
    {
        // Old home page URL, the home page now lives on the site root
        path: "/HomePage",
        redirect: "/",
    },
    {
        path: "/servicePage",
        name: "خدمات",
        component: () => import('@/Pages/ServicePage'),
        meta: {transition: 'zoom'},
    },
    {
        path: "/aboutUs",
        name: "درباره ما",
        component: () => import('@/Pages/AboutUs'),
        meta: {transition: 'zoom'},
    },
    {
        path: "/termsAndConditions",
        name: "قوانین و مقررات",
        component: () => import('@/Pages/TermsAndConditions'),
        meta: {transition: 'zoom'},
    },
    {
        path: "/contactUs",
        name: "تماس با ما",
        component: () => import('@/Pages/ContactUs'),
        meta: {transition: 'zoom'},
    },
    {
        path: "/ServiceDetails/:id/:title?",
        name: "ServiceDetails",
        component: () => import('@/Pages/ServiceDetails'),
        meta: {transition: 'zoom'},
    },

    {
        path: "/BlogPostsDetails/:id/:title?",
        name: "blogPostsDetails",
        component: () => import('@/Pages/BlogPostsDetails'),
        meta: {transition: 'zoom'},
    },
    {
        path: "/ServiceDetails2/:id/:title?",
        name: "serviceDetails2",
        component: () => import('@/Pages/ServiceDetails2'),
        meta: {transition: 'zoom'},
    },
    {
        path: "/BlogPosts",
        name: "مقالات",
        component: () => import('@/Pages/BlogPosts'),
        meta: {transition: 'zoom'},
    },
/*    {
        path: "/CVSubmit",
        name: "همکاری با ما",
        component: () => import('@/Pages/CVSubmit'),
        meta: {transition: 'zoom'},
    },*/
    {
        path: "/Tutorials",
        name: "آموزش ها",
        component: () => import('@/Pages/TutorialsPage'),
        meta: {transition: 'zoom'},
    },
    {
        path: "/VideosPage",
        name: "ویدیوها",
        component: () => import('@/Pages/VideosPage'),
        meta: {transition: 'zoom'},
    },
    {
        path: "*",
        name: "صفحه یافت نشد",
        component: () => import('@/Pages/NotFound'),
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return savedPosition || {x: 0, y: 0};
    },
});

export default router;
